import api from "./api";

export const login = async (email, password) => {
  const response = await api.post("/auth/login", { email, password });
  if (response.data.access_token) {
    localStorage.setItem("access_token", response.data.access_token);
    localStorage.setItem("refresh_token", response.data.refresh_token);
    localStorage.setItem("session_id", response.data.session_id);
  }
  return response.data;
};

export const signUp = async (userData) => {
  const response = await api.post("/auth/sign-up", userData);
  return response.data;
};

export const logout = async () => {
  try {
    await api.post("/auth/logout");
  } catch (error) {
    console.error("Logout failed", error);
  } finally {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("session_id");
  }
};

export const getCurrentUser = () => {
  // This would typically fetch user details from an endpoint like /auth/me
  // For now, we just check if we have a token
  return localStorage.getItem("access_token");
};
